import { createContext } from 'react';
import { UploadDocContextType } from '../types';

const UploadDocContext = createContext<UploadDocContextType>(['', null,false,null,new FormData(),null]);

export default UploadDocContext;
